<template>
    <div class="message-content">
        <div style="text-align: center;margin-bottom: 0.2rem;margin-top: 0.2rem;">
            <el-radio-group v-model="type" size="mini" @change="handleChange">
                <el-radio-button label="1">自定义</el-radio-button>
                <el-radio-button label="2">选择模版</el-radio-button>
            </el-radio-group>
        </div>
        <el-input ref="inputRef" v-if="type === '1'" :autosize="{ minRows: 2, maxRows: 5 }" :maxlength="maxlength"
            show-word-limit size="mini" type="textarea" v-model="message" placeholder="短信内容,内容中不能出现【】"
            style="white-space: pre" @blur="handleClick"></el-input>
        <choose-template v-if="type === '2'" @handleChooesd="handleChooesd" :task_id="task_id" />
        <el-checkbox v-if="type === '1'" style="margin-top: 0.1rem;" v-model="insertCompanyName"
            @change="handleInsertCompanyNameChange">插入公司名称</el-checkbox>
        <div v-if="type === '1'" style="margin-top: 0.2rem;">
            <div style="text-align: center;margin-bottom: 0.2rem;">短信预览</div>
            <el-input readonly :autosize="{ minRows: 2, maxRows: 5 }" size="mini" type="textarea" v-model="message_pre"
                placeholder="" style="white-space: pre"></el-input>
        </div>
    </div>
</template>

<script>
import ChooseTemplate from './ChooseTemplate'
export default {
    name: "MessageContent",
    components: { ChooseTemplate },
    props: {
        task_id: {
            type: Number,
        },
        company_name: {
            type: String
        }
    },
    data() {
        return {
            message: '',
            type: '1',
            template_id: null,
            insertCompanyName: false,
            cursorPosition: 0,
            message_pre: ''
        }
    },
    methods: {
        handleChange(val) {

        },
        handleChooesd(val) {
            this.template_id = val
        },
        handleInsertCompanyNameChange(val) {
            if (val) {
                this.insertData(this.company_name)
            } else {
                this.message = this.message.replace(this.company_name, '')
                this.$nextTick(() => {
                    this.$refs.inputRef.$refs.textarea.focus();
                    this.$refs.inputRef.$refs.textarea.setSelectionRange(this.message.length, this.message.length);
                });
            }
        },
        handleClick(e) {
            // 获取光标位置
            this.cursorPosition = e.srcElement.selectionStart;
        },
        insertData(val) {
            const before = this.message.slice(0, this.cursorPosition);
            const after = this.message.slice(this.cursorPosition);
            const dataToInsert = val;
            this.message = before + dataToInsert + after;

            // 重新设置光标位置
            this.$nextTick(() => {
                this.$refs.inputRef.$refs.textarea.focus();
                // this.$refs.inputRef.$refs.textarea.setSelectionRange(this.cursorPosition + dataToInsert.length, this.cursorPosition + this.message.length);
                this.$refs.inputRef.$refs.textarea.setSelectionRange(this.message.length, this.message.length);
            });
        },
    },
    computed: {
        maxlength() {
            // if (this.insertCompanyName) {
            return 70 - 11
            // } else {
            //     return 70 - 11
            // }
        }
    },
    watch: {
        message(n) {
            this.message_pre = '【企业火】' + n + '拒收请回复R'
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/MessageContent.vue